export default "__VITE_ASSET__CIFzFdyq__"